import Layout from '../../components/ui/Layout';
import { ProfileNav } from './PersonalDetails';
import { IconMail, IconCheck } from '@tabler/icons-react';

export default function EmailOutlook() {
  return (
    <Layout>
      <div style={{ display: 'flex', flex: 1, minHeight: '100vh' }}>
        <ProfileNav active="Email & Outlook" />
        <div style={{ flex: 1, padding: 'var(--main-padding)' }}>
          <h1 style={{ fontSize: 22, fontWeight: 400, marginBottom: 4 }}>Email & Outlook</h1>
          <p style={{ fontSize: 13, color: 'var(--color-text-tertiary)', marginBottom: 28 }}>Connect your Microsoft Outlook account</p>
          <div style={{ background: '#E6F1FB', border: '0.5px solid #B5D4F4', borderRadius: 'var(--radius-lg)', padding: '20px 24px', display: 'flex', alignItems: 'center', gap: 16, marginBottom: 20 }}>
            <div style={{ width: 48, height: 48, background: '#0078D4', borderRadius: 'var(--radius-md)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <IconMail size={24} color="white" stroke={1.5} />
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 14, fontWeight: 400, color: '#185FA5', marginBottom: 3 }}>Microsoft Outlook</div>
              <div style={{ fontSize: 12, color: '#185FA5', opacity: 0.8 }}>Not connected · Connect to send automated emails from your account</div>
            </div>
          </div>
          <button style={{ background: '#0078D4', color: '#fff', border: 'none', borderRadius: 'var(--radius-md)', padding: '10px 20px', fontSize: 13, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 8 }}>
            <IconMail size={15} stroke={1.5} /> Connect Microsoft Outlook
          </button>
          <div style={{ marginTop: 28 }}>
            <div style={{ fontSize: 14, fontWeight: 400, marginBottom: 14 }}>Automated emails</div>
            <div style={{ background: 'var(--color-bg-primary)', border: '0.5px solid var(--color-border-light)', borderRadius: 'var(--radius-lg)', overflow: 'hidden' }}>
              {[
                { label: 'Daily branch summary', desc: 'Sent at 07:00 each morning' },
                { label: 'Crash detection alert', desc: 'Sent immediately when detected' },
                { label: 'Overdue check escalation', desc: 'Sent after 2 hours overdue' },
                { label: 'Weekly performance report', desc: 'Sent every Monday at 08:00' },
              ].map((item, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '14px 18px', borderBottom: i < 3 ? '0.5px solid var(--color-border-light)' : 'none' }}>
                  <IconCheck size={16} color="var(--color-text-tertiary)" stroke={1.5} />
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 13, color: 'var(--color-text-primary)' }}>{item.label}</div>
                    <div style={{ fontSize: 12, color: 'var(--color-text-tertiary)', marginTop: 2 }}>{item.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
